export default __webpack_public_path__ + "16af2edae0ae08aff5c98a7ad004b26c.png";